/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {GetCurrentData} from '../../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../../_metronic/helpers'
import {REGION_API_URLS} from '../../../../../Utils/Constant/ConstantForWebsite'
import {toLower} from 'lodash'
import { ROLES } from '../../../../../Utils/Constant/roles'

const initialState = {
  usedFeatures: {},
  userDetails: {},
  userCreditHistory: {},
  survey: {
    isLoading: false,
  },
  soundNotification: {
    newInbox: false,
    newNotification: false,
  }
}
const API_URL = ENV().REACT_APP_API_URL
const API_URL_V2 = ENV().REACT_APP_API_V2_URL
const API_URL_V3 = ENV().REACT_APP_API_V3_URL

const fetchDataApiV3 = async (url: string, data: any, region: string) => {
  const domain = region !== defaultRegion ? (region && REGION_API_URLS[region.toUpperCase()]) || API_URL_V3 : API_URL_V3
  const response = await axios.post(`${domain}${url}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`, region: region},
  })

  return response.data
}

const getProductData = async (url: string, params: any = {}) => {
  const response = await axios.get(`${API_URL_V2}${url}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params,
  })

  return response.data
}

export const fetchAsyncUserDetails: any = createAsyncThunk(
  'userDetails/fetchAsyncUserDetails',
  async (params: any, thunkApi) => {
    const response = await axios.get(`${API_URL}user/me`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params,
    })

    const userDetail = response.data?.data?.user
    const isBcardUser = userDetail?.tagNames?.includes('B-card') && userDetail?.features?.includes('Wallet Card')

    if (localStorage.getItem('firstimeLogin') === 'true' && isBcardUser) {
      let redirectUrl = ''
      
      const product = await getProductData('products/bcard')
      const productId = product?.data?.product?._id || ''
      
      if (productId) {
        const accessToProduct = await getProductData(`products/${productId}/access`)
        const dataAccessToProduct = accessToProduct?.data
        const isAccessWalletCard = dataAccessToProduct?.hasAccess

        if (!isAccessWalletCard) {
          redirectUrl = '/wallet-card/subscription'
        } else {
          redirectUrl = [ROLES.OWNER, ROLES.USER_ADMIN].includes(userDetail?.role) ? '/card-templates/create' : '/wallet-card'
        }
      }
      
      if (redirectUrl) {
        localStorage.setItem('redirectUrl', redirectUrl)
      }
    }

    let credit = response.data?.data.credits

    /** To get data from international service */
    const currentUser = GetCurrentData()
    if (currentUser && toLower(currentUser?.region) !== defaultRegion) {
      const response = await fetchDataApiV3(
        'billing',
        {
          action: 'find_balance',
        },
        currentUser?.region as string
      )
      if (response?.data) {
        credit = response?.data
      }
    }
    thunkApi?.dispatch(GetUserNotificationAlert())
    const result = {
      ...response.data,
      data: {
        ...response.data?.data,
        credits: credit,
      },
    }
    return result
  }
)
export const updateOwnersGlobalSetting: any = createAsyncThunk(
  'userDetails/updateOwnersGlobalSetting',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}user/updateOwnersGlobalSetting`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    response.data.message && toast.success(response.data.message)
    thunkApi?.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)
export const uploadProfileImage: any = createAsyncThunk(
  'userDetails/uploadProfileImage',
  async (data: any) => {
    const response = await axios.post(`${API_URL}fileStroage/uploadFile`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    return response.data
  }
)
export const CreditHistory: any = createAsyncThunk(
  'userDetails/CreditHistory',
  async (data: any) => {
    const response = await axios.get(`${API_URL}creditTransactions`, {
      params: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    return response.data
  }
)

export const UpdateSurvey: any = createAsyncThunk(
  'userDetails/survey',
  async (data: any, thunkApi) => {
    const response = await axios.patch(`${API_URL}user/feedback/survey`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })

    thunkApi?.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

export const GetUserNotificationAlert: any = createAsyncThunk(
  'userDetails/sound-setting',
  async (data: any) => {
    const response = await axios.get(`${API_URL}user/notification-sound`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    return response.data
  }
)

export const GetUserUsedFeature: any = createAsyncThunk(
  'userDetails/new-used-feature',
  async (data: any) => {
    const response = await axios.get(`${API_URL}user/used-feature`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    return response.data
  }
)

const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    setUsedFeatures: (state, action) => {
      state.usedFeatures = { ...state.usedFeatures, ...action.payload };
    },
  },
  extraReducers: {
    [fetchAsyncUserDetails.pending]: (state) => {},
    [fetchAsyncUserDetails.fulfilled]: (state, {payload}) => {
      // {
      //   payload.status === false && toast.error(payload.message)
      // }
      return {...state, userDetails: payload}
    },
    [GetUserNotificationAlert.fulfilled]: (state, {payload}) => {
      return {...state, soundNotification: payload?.data}
    },
    [GetUserUsedFeature.fulfilled]: (state, {payload}) => {
      return {...state, usedFeatures: payload?.data}
    },
    [fetchAsyncUserDetails.rejected]: () => {},
    [CreditHistory.fulfilled]: (state, {payload}) => {
      {
        payload.status === false && toast.error(payload.message)
      }
      return {...state, userCreditHistory: payload}
    },
    [UpdateSurvey.pending]: (state) => {
      return {...state, survey: {
        isLoading: true
      }}
    },
    [UpdateSurvey.fulfilled]: (state, {payload}) => {
      if (payload?.status === true) {
        toast.success(payload?.message)
      } else {
        toast.error(payload?.message ?? 'Something went wrong')
      }
      return {...state, survey: {
        ...payload,
        isLoading: false,
      }}
    },
    [UpdateSurvey.rejected]: (state, {payload}) => {
      toast.error(payload?.message ?? 'Something went wrong')
      return {...state, survey: {
        ...payload,
        isLoading: false,
      }}
    },
  },
})

export const getSoundNotificationSetting = (state: any) => state.userDetails?.soundNotification;

export const getAllUserDetails = (state: any) =>
  state.userDetails.userDetails ? state.userDetails.userDetails.data?.user : {}

export const getAllUserCreditHistory = (state: any) => state.userDetails.userCreditHistory?.data

export const getIsDefaultRegion = (state: any) => {

  if (!state.userDetails.userDetails.data?.user?.region) {
    return true
  }

  return state.userDetails.userDetails.data?.user?.region === defaultRegion 
}

export const getDefaultRegion = (state: any) => {
  return state.userDetails.userDetails.data?.user?.region
}

export const getDefaultShortUrl = (state: any) => {
  if (state?.userDetails?.userDetails?.data?.user?.customShortLink?.status) {
    return state?.userDetails?.userDetails?.data?.user?.customShortLink?.domain
  }

  return getIsDefaultRegion(state)
    ? ENV().REACT_APP_SHORTURL
    : ENV().REACT_APP_SHORTURL_INTERNATIONAL
}

export const getDefaultOptOutUrl = (state: any) => {
  return getIsDefaultRegion(state)
    ? ENV().REACT_APP_OPTOUT
    : ENV().REACT_APP_OPTOUT_INTERNATIONAL
}

export const getDefaultOptOutUrlCount = (state: any) => {
  return getIsDefaultRegion(state)
    ? `STOP: ${ENV().REACT_APP_OPTOUT}/xxxxxx  `.length
    : `STOP: ${ENV().REACT_APP_OPTOUT_INTERNATIONAL}/xxxxxx  `.length
}

export const getIsOwner = (state: any) => {
  return state.userDetails.userDetails.data?.user?.role === 'owner'
}

export const getUserSubmitSurvey = (state: any) => state.userDetails?.survey

export const getUsedFeature = (state: any) => state.userDetails?.usedFeatures;

export default userDetailsSlice.reducer

export const { setUsedFeatures } = userDetailsSlice.actions;
